export function scoreAnswer(correctAnswer: number, givenAnswer: number | null | undefined): boolean {
  return Number.isInteger(givenAnswer) && givenAnswer === correctAnswer;
}

export function countCorrect(answers: Array<{ isCorrect: boolean }>): number {
  return answers.filter((answer) => answer.isCorrect).length;
}
